import { InjectionToken, Type } from '@angular/core';

import { CobTitleComponent } from '../components/templates/cob-title/cob-title.component';
import { DynamicTableTemplateDateComponent } from '../components/templates/date/date.component';
import { StatusComponent } from '../components/templates/status/status.component';
import { AdditionalRequestsComponent } from '../components/templates/additional-requests/additional-requests.component';
import { ClaimsCellComponent } from '../components/templates/claims/claims-cell.component';
import { DynamicTableTemplateInitialsComponent } from '../components/templates/initials/dynamic-table-template-initials.component';
import { defaults } from 'lodash';
import { TextCellComponent } from '../components/templates/text/text-cell.component';
import { ExpandCellComponent } from '../components/templates/expand-cell/expand-cell.component';
import { SimpleSummaryCellComponent } from '../components/templates/simple-summary/simple-summary-cell.component';

export type DynamicTableCells = Record<string, Type<unknown>>;

export const DYNAMIC_TABLE_CELLS = new InjectionToken<DynamicTableCells>(
  'Registry of dynamic table cells'
);

export function provideDynamicTableCells(columnTemplates: DynamicTableCells) {
  return {
    provide: DYNAMIC_TABLE_CELLS,
    useValue: defaults(columnTemplates, DYNAMIC_TABLE_CELLS_CORE),
  };
}

export const DYNAMIC_TABLE_CELLS_CORE = {
  'cob-title': CobTitleComponent,
  initials: DynamicTableTemplateInitialsComponent,
  status: StatusComponent,
  date: DynamicTableTemplateDateComponent,
  'additional-requests': AdditionalRequestsComponent,
  claims: ClaimsCellComponent,
  text: TextCellComponent,
  expand: ExpandCellComponent,
  'simple-summary': SimpleSummaryCellComponent,
};
